export enum ScheduledPaymentStatus {
  Scheduled = 'scheduled',
  Processing = 'processing',
  Complete = 'complete',
  Rescheduled = 'rescheduled',
  Cancelled = 'cancelled',
  Failed = 'failed'
}
